import { HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";


export const CredentialsInterceptor: HttpInterceptorFn = (request, next) => {
  let clonedRequest = request.clone({
    withCredentials: true
  })
  return next(clonedRequest)
}